import { Navigate, Outlet } from "react-router";
import { useAuth } from "./AuthProvider";
import { USER_ROLES } from "./userRoles";

const TestDataGuard = () => {
  const { role } = useAuth();

  if (role !== USER_ROLES.admin && role !== USER_ROLES.clinical_coder_admin) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default TestDataGuard;
